export default "__VITE_ASSET__2b68e91f__"